<template>
  <div>
    <div class="columns is-multiline">
      <div style="width:200px">
        <div class="box" style="padding-right:0;margin-right:12px">
          <input class="input" style="width: 153px;height: 25px;margin-bottom: 12px;font-size:14px" v-model="selectValue">
          <div style="overflow-y: scroll;height: calc(100vh - 165px);">
            <div v-for="(item, idx) in list" :key="`log-${idx}`">
              <div class="log-item unselect"
                   style="cursor:unset"
                   :class="{'selected-folder': item.selected}"
                   @click="addChild(item)">{{ item.name }}</div>
              <div v-if="item.selected">
                <div v-for="(child, c_idx) in item.child" :key="`c${c_idx}`">
                  <div class="flex log-item unselect" style="cursor:unset"
                        @click="getUwsgiLogDetail(item.name, child.name)">
                    <div style="margin-right:2px">┕</div>
                    <div>{{ child.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="flex:1" v-show="value">
        <div class="editor-wrapper">
          <textarea ref="editorTemplate"></textarea>
        </div>
        <!--<div class="box">
          <div v-for="(val, val_idx) in value" :key="`val${val_idx}`" v-html="val"></div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  export default {
    name: "ServiceLog",
    created() {
      this.getData();
      this.$nextTick(() => {
        this.initCodeEditor();
      })
    },
    data() {
      return {
        list: [],
        list_origin: [],
        value: '',
        editor: undefined,
        selectValue: ''
      }
    },
    watch: {
      selectValue(n) {
        this.setList();
      }
    },
    methods: {
      initCodeEditor() {
        this.editor = window.ace.edit(this.$refs.editorTemplate);
        this.editor.setTheme("ace/theme/monokai");
        this.editor.session.setMode("ace/mode/livescript");
        this.editor.setOptions({
          enableBasicAutocompletion: true,
          enableSnippets: true,
          enableLiveAutocompletion: true,
          tabSize: 2,
          newLineMode: 'unix',
          fontSize: '13px'
        });
      },
      setList() {
        let list = this.cloneItem(this.list_origin);

        let filter_list = [];
        list.forEach(item => {
          let name = item.name.split('/')[0];
          if(filter_list.indexOf(name)===-1) {
            if(this.selectValue!=='' && name.indexOf(this.selectValue)>-1) {
              filter_list.push(name);
            } else if(this.selectValue==='') {
              filter_list.push(name);
            }
          }
        })
        filter_list = filter_list.sort((a, b) => {
          return parseInt(b.replaceAll('-','')) - parseInt(a.replaceAll('-',''))
        })

        let result = [];
        filter_list.forEach(item => {
          result.push({'name': item, child: [], 'selected': false})
        })
        this.list = result;
      },
      getData() {
        let start = moment().subtract(1, 'months')
        let end = moment()
        let dates = [];
        while (start < end) {
          dates.push({name: end.format('YYYY-MM-DD'), selected: false, child: []});
          end = end.subtract(1, 'days')
        }
        this.list = dates;
        this.list_origin = this.cloneItem(dates);
      },
      addChild(item) {
        item.selected = !item.selected;

        if (item.child.length === 0) {
          this.$axios.get(`admin/launchpack/service/${this.$route.query.id}/uwsgi_log/date/${item.name}`).then(res => {
            let list = [];
            res.data.forEach(item => {
              list.push({name: item.split('/')[1], selected: false});
            })
            item.child = list;
          })
        }
      },
      getUwsgiLogDetail(folder_name, log_name) {
        let full_name = `${folder_name}/${log_name}`;
        this.$axios.get(`admin/launchpack/service/${this.$route.query.id}/uwsgi_log/content`, {
          params: {
            log_name: full_name
          }
        }).then(res => {
          this.value = this.cloneItem(res.data);
          this.editor.setValue(this.value);
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .log-item
    font-size 12px

  .log-item:hover, .selected-folder
    background-color #CAE9FD

</style>

<style lang="stylus">
  .editor-wrapper
    width 100%
    height 100%
    background-color rgba(60, 60, 60, .5)

  .ace_editor
    margin 0
    height 100%

  .modal-page-prop .sweet-modal
    max-width 1000px

  .editor-container .sweet-modal
    top 44%
</style>
